var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"ui--back-button",on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('b-icon',{staticClass:"pt-2",attrs:{"icon":"keyboard-arrow-left"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }